<template>
  <div v-if="isLogged" class="viewed-vacancies">
    <div class="viewed-vacancies__content">
      <div class="viewed-vacancies__title">{{$tVacancies('Viewed')}}</div>
      <div ref="carousel" class="viewed-vacancies__list-wrap">
        <ul class="viewed-vacancies__list">
          <li v-if="pending" class="viewed-vacancies__item _preloader">
            <BasePreloader/>
          </li>
          <li v-for="item in items"
              :key="item.id"
              :class="item.resume_sended ? '_accent' : null"
              class="viewed-vacancies__item">
            <div class="viewed-vacancies__item-content">
              <a :href="item.src"
                 class="viewed-vacancies__link">{{item.title}}</a>
              <div class="viewed-vacancies__param"
                   v-if="item.salary_from || item.salary_to">
                {{item.salary_from | formatCurrency}} - {{item.salary_to | formatCurrency}}
                {{currentCurrency.currency}}/{{$tGlobal(getSalaryTypeById(item.salary_type))}}
              </div>
              <BaseSvg v-if="item.resume_sended"
                       name="ico-check-round"
                       class="viewed-vacancies__check-ico"/>
            </div>
          </li>
        </ul>
      </div>
      <button ref="prev" class="viewed-vacancies__nav  _prev  base-btn  base-btn--grey-blue">
        <BaseSvg name="ico-arrow-light"/>
      </button>
      <button ref="next" class="viewed-vacancies__nav  _next  base-btn  base-btn--grey-blue">
        <BaseSvg name="ico-arrow-light"/>
      </button>
    </div>
    <div ref="pagination" class="viewed-vacancies__pagination"></div>
  </div>
</template>

<script>
  import {http} from "../axios";
  import Swiper from 'swiper';

  export default {
    data() {
      return {
        swiper: null,
        pending: false,
        items: []
      }
    },
    computed: {
      isLogged() {
        return this.$store.getters['user/isLogged']
      },
      currentCurrency() {
        return this.$store.state.currentCurrency
      },
    },
    methods: {
      createSwiper() {
        this.swiper = new Swiper(this.$refs['carousel'], {
          wrapperClass: 'viewed-vacancies__list',
          slideClass: 'viewed-vacancies__item',
          slidesPerView: 1,
          watchOverflow: true,
          navigation: {
            prevEl: this.$refs['prev'],
            nextEl: this.$refs['next'],
            disabledClass: '_disabled',
            hiddenClass: '_hidden',
            lockClass: '_hidden'
          },
          pagination: {
            el: this.$refs['pagination'],
            type: 'bullets',
            bulletClass: 'viewed-vacancies__pagination-item',
            bulletActiveClass: '_active',
            lockClass: '_hidden'
          },
        });
      },
      load() {
        if (!this.isLogged) return
        this.pending = true

        http.get('/api/vacancies/viewed').then(({data}) => {
          this.items = data.data
        }).finally(() => {
          this.pending = false
          setTimeout(() => {
            this.createSwiper()
          })
        })
      },
      getSalaryTypeById(id) {
        const salaryType = this.$store.state.salaryTypes.find(type => type.id === id)
        return salaryType ? salaryType.shortName : null
      }
    },
    created() {
      this.load()
    },
    beforeDestroy() {
      if (this.swiper) {
        this.swiper.destroy();
      }
    }
  }
</script>

<style lang="less">

</style>
